import { DateTime } from 'luxon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, styled } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import '../../pages/Licenses/licenses.scss';
interface Props {
  showModalLicense: boolean
  closeModal: Function
  licenseTransactions: any[]
}

const LicenseTransactionsModal = ({
  showModalLicense, 
  closeModal,
  licenseTransactions
}: Props) => {
  const { t } = useTranslation();
  const columnsTransactions = [
    {
      title: t('EMAIL'),
      dataIndex: 'fromEmail',
      key: 'email'
    },
    {
      title: t('TO'),
      dataIndex: 'toEmail',
      key: 'to'
    },
    {
      title: t('DATE'),
      dataIndex: 'date',
      key: 'date'
    }
  ];

  const StyledTableRow = styled(TableRow)(() => ({
    '&:nth-of-type(odd)': {
      backgroundColor: '#e6f7ff'
    }
  }));

  return   <Dialog className='dialog' fullWidth open={showModalLicense} onClose={() => closeModal()}>
    <DialogContent>
      <TableContainer component={Paper}>
      <Table  aria-label="simple table">
        <TableHead>
          <StyledTableRow>
            {columnsTransactions.map((item) => {
              return <TableCell align="left" key={item.key}>{item.title}</TableCell>;
            })}
          </StyledTableRow>
        </TableHead>
       <TableBody>
          {licenseTransactions.map((row) => (
            <TableRow key={row.sensorId}
            >
              <TableCell align="left">{row.fromEmail}</TableCell>
              <TableCell align="left">{row.toEmail}</TableCell>
              <TableCell align="left">{DateTime.fromJSDate(new Date(row.date)).toFormat('dd-LL-yyyy HH:mm')}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      {!(licenseTransactions.length > 0) && <div className='noData'>No data</div>}
    </TableContainer>
    </DialogContent>
  </Dialog>;
};

export default LicenseTransactionsModal;